import type {
  ConsentChannel,
  CustomerActivity,
  FollowUpKind,
  InteractionKind,
  LoyaltyTransactionType,
  TimelineEntryKind,
} from '@horevia/contracts';

/** Libellés et tons de la section CRM (ADR-025). */

export const ACTIVITY_ORDER: CustomerActivity[] = ['NEW', 'ACTIVE', 'INACTIVE', 'NONE'];
export const FOLLOW_UP_KINDS: FollowUpKind[] = ['BIRTHDAYS', 'INACTIVE', 'NO_CONSENT', 'SEGMENT'];
export const CONSENT_CHANNEL_ORDER: ConsentChannel[] = ['WHATSAPP', 'SMS', 'EMAIL', 'PHONE'];
export const INTERACTION_KINDS: InteractionKind[] = [
  'CALL',
  'WHATSAPP',
  'EMAIL',
  'SMS',
  'VISIT',
  'NOTE',
  'OTHER',
];
export const TIMELINE_KINDS: TimelineEntryKind[] = [
  'STAY',
  'ORDER',
  'PAYMENT',
  'LOYALTY',
  'INTERACTION',
  'CONSENT',
];

export function activityTone(activity: CustomerActivity): 'green' | 'blue' | 'amber' | 'neutral' {
  switch (activity) {
    case 'NEW':
      return 'blue';
    case 'ACTIVE':
      return 'green';
    case 'INACTIVE':
      return 'amber';
    default:
      return 'neutral';
  }
}

export function transactionTone(type: LoyaltyTransactionType): 'green' | 'amber' | 'blue' | 'red' {
  switch (type) {
    case 'EARN':
      return 'green';
    case 'REDEEM':
      return 'amber';
    case 'ADJUST':
      return 'blue';
    default:
      return 'red';
  }
}

/** Ton d'un palier selon son rang (le premier = bronze, puis argent, or…). */
export function tierTone(index: number): 'amber' | 'neutral' | 'violet' | 'blue' {
  return (['amber', 'neutral', 'violet', 'blue'] as const)[index % 4] ?? 'neutral';
}

/**
 * Lien WhatsApp « cliquer pour discuter » avec message pré-rempli (D-H67) :
 * numéro E.164 sans `+`, texte encodé. Aucune API, le navigateur ouvre
 * WhatsApp Web ou l'application du poste.
 */
export function whatsAppLink(phone: string, text: string): string {
  const digits = phone.replace(/[^\d]/g, '');
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
}

/** Lien `tel:` pour un appel depuis le poste. */
export function phoneLink(phone: string): string {
  return `tel:${phone}`;
}
